import type { DocumentRowUi } from "../types/documentManagementUiTypes";

const VIDEO_EXTENSIONS = new Set([
  ".mp4",
  ".mov",
  ".avi",
  ".mkv",
  ".webm",
  ".m4v",
]);

export type LibraryMediaFilter = "document" | "video";

function fileNameExtensionLower(fileName: string): string {
  const base = (fileName || "").trim().replace(/\\/g, "/");
  const name = base.split("/").pop() || base;
  const dot = name.lastIndexOf(".");
  if (dot < 0) return "";
  return name.slice(dot).toLowerCase();
}

export function isLibraryVideoRow(row: DocumentRowUi): boolean {
  const mime = (row.mime_type || "").toLowerCase();
  if (mime.startsWith("video/")) return true;
  return VIDEO_EXTENSIONS.has(fileNameExtensionLower(row.original_file_name));
}

export function isLibraryPdfRow(row: DocumentRowUi): boolean {
  const mime = (row.mime_type || "").toLowerCase();
  if (mime === "application/pdf") return true;
  return fileNameExtensionLower(row.original_file_name) === ".pdf";
}

export function isLibraryDocumentRow(row: DocumentRowUi): boolean {
  return !isLibraryVideoRow(row);
}

export function filterLibraryRowsByMedia(
  rows: DocumentRowUi[],
  filter: LibraryMediaFilter
): DocumentRowUi[] {
  return rows.filter((row) =>
    filter === "video" ? isLibraryVideoRow(row) : isLibraryDocumentRow(row)
  );
}

/** Remote `/rag/video/` preview is not expected when ingest failed. */
export function canPreviewLibraryVideo(uploadStatus: string): boolean {
  return (uploadStatus || "").toLowerCase() !== "failed";
}
